import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';

import CropIconMapping from 'components/CropIconMapping';
import { scaleToMapPDF as scale } from 'screens/Property/helpers/mapApiHelpers';
import formatNumber from 'helpers/formatNumber';

export const renderCropLegendRows = ({
  crops,
  cropColors,
  size = 'small',
  show
}) => {
  const isSmall = size === 'small';
  const fontSize = `${scale(isSmall ? 8 : 12)}px`;
  const lineHeight = `${scale(isSmall ? 14 : 20)}px`;
  const rowClasses = isSmall ? '' : 'border-b border-neutral-20';

  return crops.map((crop, i) => {
    const shouldWrap = crop.name.length > 25;

    const rowStyles = isSmall
      ? { height: scale(14) + (shouldWrap && show ? scale(14) : 0) }
      : {
          height: scale(24) + (shouldWrap && show ? scale(20) : 0),
          paddingBottom: scale(1)
        };

    return (
      <Row
        key={crop.id}
        className={rowClasses}
        style={{ marginTop: i > 0 ? scale(4) : 0, ...rowStyles }}
        align={shouldWrap && show ? 'top' : 'middle'}
        gutter={scale(2)}
      >
        <Col>
          <div
            style={{
              background: cropColors[crop.id],
              width: lineHeight,
              height: lineHeight
            }}
          />
        </Col>
        <Col>
          <CropIconMapping size={scale(12)} cropObject={crop} />
        </Col>
        <Col
          flex="auto"
          style={{
            fontSize,
            lineHeight,
            whiteSpace: shouldWrap ? 'normal' : 'nowrap',
            wordBreak: 'break-word',
            overflow: 'hidden',
            width: shouldWrap ? '60%' : 'auto'
          }}
        >
          <div>{crop.name}</div>
        </Col>
        <Col
          style={{
            fontSize,
            lineHeight
          }}
        >
          {formatNumber(crop.area, 'ac')}
        </Col>
      </Row>
    );
  });
};

const cropLegendDefaultPropStyle = {};
const CropLegend = ({
  crops,
  cropColors,
  show = true,
  style = cropLegendDefaultPropStyle,
  limit = 0
}) => {
  if (!show) return null;

  const limitedCrops = limit ? crops.slice(0, limit) : crops;

  return (
    <div
      className="absolute z-2 bg-white border-neutral-60"
      style={{
        width: scale(200),
        padding: scale(8),
        paddingBottom: scale(16),
        borderWidth: scale(0.5),
        ...style
      }}
    >
      <Row
        justify="center"
        style={{
          marginBottom: scale(8),
          fontSize: scale(10),
          lineHeight: `${scale(16)}px`,
          fontWeight: 500
        }}
      >
        Map Legend
      </Row>
      {renderCropLegendRows({ crops: limitedCrops, cropColors, show })}
    </div>
  );
};

CropLegend.propTypes = {
  crops: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      area: PropTypes.number.isRequired
    })
  ).isRequired,
  cropColors: PropTypes.objectOf(PropTypes.string).isRequired,
  show: PropTypes.bool,

  style: PropTypes.objectOf(),
  limit: PropTypes.number
};

export default CropLegend;
